var _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgStudentRes = function SvgStudentRes(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 69,
      height: 68,
      viewBox: "0 0 69 68",
      fill: "none",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2 || (_ref2 =
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.375 3.773C15.375 2.8318 16.2759 2.15227 17.1809 2.41084L45.5142 10.5061C46.1224 10.6798 46.5417 11.2357 46.5417 11.8682V65.8756H45.125V11.8682L16.7917 3.773V65.8756H15.375V3.773Z"
    })), _ref3 || (_ref3 =
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M46.5417 20.543H59.2917C60.0741 20.543 60.7084 21.1772 60.7084 21.9596V65.8763H59.2917V21.9596H46.5417V20.543Z"
    })), _ref4 || (_ref4 =
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2.625 13.4596C2.625 12.6772 3.25926 12.043 4.04167 12.043H16.7917V13.4596H4.04167V65.8763H2.625V13.4596Z"
    })), _ref5 || (_ref5 =
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M55.4449 51.1281L55.1885 51.7606L55.6789 52.2353C56.0982 52.6412 56.3569 53.207 56.3569 53.835C56.3569 54.0037 56.3383 54.1668 56.3035 54.3229L56.1978 54.797L56.5015 55.176C56.9181 55.6959 57.1666 56.3538 57.1666 57.0725C57.1666 58.5767 56.0726 59.8254 54.6369 60.0663V58.287C54.6369 58.0076 54.4104 57.7811 54.1309 57.7811C53.8515 57.7811 53.625 58.0076 53.625 58.287V60.0663C52.1892 59.8254 51.0952 58.5767 51.0952 57.0725C51.0952 56.3539 51.3436 55.6961 51.7601 55.1763L52.0638 54.7972L51.958 54.3231C51.9231 54.167 51.9045 54.0038 51.9045 53.835C51.9045 53.2069 52.1634 52.6409 52.5829 52.235L53.0733 51.7604L52.8171 51.1279C52.7512 50.9652 52.7144 50.7864 52.7144 50.5965C52.7144 49.8141 53.3486 49.1799 54.131 49.1799C54.9134 49.1799 55.5477 49.8141 55.5477 50.5965C55.5477 50.7865 55.5109 50.9653 55.4449 51.1281ZM53.625 61.0888C51.6283 60.8399 50.0833 59.1366 50.0833 57.0725C50.0833 56.1157 50.4153 55.2364 50.9704 54.5436C50.9195 54.3156 50.8926 54.0784 50.8926 53.835C50.8926 52.9216 51.2709 52.0965 51.8792 51.5078C51.7652 51.2264 51.7025 50.9188 51.7025 50.5965C51.7025 49.2553 52.7898 48.168 54.131 48.168C55.4723 48.168 56.5596 49.2553 56.5596 50.5965C56.5596 50.919 56.4968 51.2267 56.3827 51.5082C56.9908 52.0969 57.3688 52.9218 57.3688 53.835C57.3688 54.0783 57.342 54.3153 57.2911 54.5432C57.8464 55.2361 58.1785 56.1155 58.1785 57.0725C58.1785 59.1366 56.6335 60.8399 54.6369 61.0888V65.3704C54.6369 65.6498 54.4104 65.8763 54.1309 65.8763C53.8515 65.8763 53.625 65.6498 53.625 65.3704V61.0888Z"
    })), _ref6 || (_ref6 =
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M58.5833 4.95964C60.1342 4.95964 61.454 5.95691 61.9329 7.34726L62.0752 7.7602L62.508 7.81855C63.8914 8.00505 64.9583 9.19166 64.9583 10.6263C64.9583 12.1911 63.6898 13.4596 62.125 13.4596H53.625C52.0602 13.4596 50.7917 12.1911 50.7917 10.6263C50.7917 9.0615 52.0602 7.79297 53.625 7.79297H55.0761L55.243 7.32069C55.7295 5.94416 57.0424 4.95964 58.5833 4.95964ZM63.1179 6.49307C62.3475 4.75593 60.6078 3.54297 58.5833 3.54297C56.6045 3.54297 54.8978 4.70186 54.1024 6.3763H53.625C51.2778 6.3763 49.375 8.27909 49.375 10.6263C49.375 12.9735 51.2778 14.8763 53.625 14.8763H62.125C64.4722 14.8763 66.375 12.9735 66.375 10.6263C66.375 8.62073 64.9864 6.9405 63.1179 6.49307Z"
    })), _ref7 || (_ref7 =
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0.5 65.1667C0.5 64.3843 1.13426 63.75 1.91667 63.75L60 63.75C60.7824 63.75 61.4167 64.3843 61.4167 65.1667C61.4167 65.9491 60.7824 66.5833 60 66.5833L1.91667 66.5833C1.13426 66.5833 0.5 65.9491 0.5 65.1667Z"
    })), _ref8 || (_ref8 =
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M62.8333 65.1667C62.8333 64.3843 63.4676 63.75 64.25 63.75L67.0833 63.75C67.8657 63.75 68.5 64.3843 68.5 65.1667C68.5 65.9491 67.8657 66.5833 67.0833 66.5833L64.2507 66.5833C63.4683 66.5833 62.8333 65.9491 62.8333 65.1667Z"
    })), _ref9 || (_ref9 =
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M27.4166 16.9987H21.75L21.75 21.2487H27.4166V16.9987ZM21.75 15.582C20.9676 15.582 20.3333 16.2163 20.3333 16.9987V21.2487C20.3333 22.0311 20.9676 22.6654 21.75 22.6654H27.4166C28.199 22.6654 28.8333 22.0311 28.8333 21.2487V16.9987C28.8333 16.2163 28.199 15.582 27.4166 15.582H21.75Z"
    })), _ref10 || (_ref10 =
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.6667 16.9987H9.00001L9.00001 21.2487H14.6667V16.9987ZM9.00001 15.582C8.21761 15.582 7.58334 16.2163 7.58334 16.9987V21.2487C7.58334 22.0311 8.21761 22.6654 9.00001 22.6654H16.0833V15.582H9.00001Z"
    })), _ref11 || (_ref11 =
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.6667 28.3346H9.00001L9.00001 32.5846H14.6667V28.3346ZM9.00001 26.918C8.21761 26.918 7.58334 27.5522 7.58334 28.3346V32.5846C7.58334 33.367 8.21761 34.0013 9.00001 34.0013H16.0833V26.918H9.00001Z"
    })), _ref12 || (_ref12 =
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.6667 39.6667H9.00001L9.00001 43.9167H14.6667V39.6667ZM9.00001 38.25C8.21761 38.25 7.58334 38.8843 7.58334 39.6667V43.9167C7.58334 44.6991 8.21761 45.3333 9.00001 45.3333H16.0833V38.25H9.00001Z"
    })), _ref13 || (_ref13 =
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.6667 49.5846H9.00001L9.00001 53.8346H14.6667V49.5846ZM9.00001 48.168C8.21761 48.168 7.58334 48.8022 7.58334 49.5846V53.8346C7.58334 54.617 8.21761 55.2513 9.00001 55.2513H16.0833V48.168H9.00001Z"
    })), _ref14 || (_ref14 =
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M27.4166 28.3346H21.75L21.75 32.5846H27.4166V28.3346ZM21.75 26.918C20.9676 26.918 20.3333 27.5522 20.3333 28.3346V32.5846C20.3333 33.367 20.9676 34.0013 21.75 34.0013H27.4166C28.199 34.0013 28.8333 33.367 28.8333 32.5846V28.3346C28.8333 27.5522 28.199 26.918 27.4166 26.918H21.75Z"
    })), _ref15 || (_ref15 =
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M27.4166 39.6667H21.75L21.75 43.9167H27.4166V39.6667ZM21.75 38.25C20.9676 38.25 20.3333 38.8843 20.3333 39.6667V43.9167C20.3333 44.6991 20.9676 45.3333 21.75 45.3333H27.4166C28.199 45.3333 28.8333 44.6991 28.8333 43.9167V39.6667C28.8333 38.8843 28.199 38.25 27.4166 38.25H21.75Z"
    })), _ref16 || (_ref16 =
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M27.4166 49.5846H21.75L21.75 53.8346H27.4166V49.5846ZM21.75 48.168C20.9676 48.168 20.3333 48.8022 20.3333 49.5846V53.8346C20.3333 54.617 20.9676 55.2513 21.75 55.2513H27.4166C28.199 55.2513 28.8333 54.617 28.8333 53.8346V49.5846C28.8333 48.8022 28.199 48.168 27.4166 48.168H21.75Z"
    })), _ref17 || (_ref17 =
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M40.1666 16.9987H34.5L34.5 21.2487H40.1666V16.9987ZM34.5 15.582C33.7176 15.582 33.0833 16.2163 33.0833 16.9987V21.2487C33.0833 22.0311 33.7176 22.6654 34.5 22.6654H40.1666C40.9491 22.6654 41.5833 22.0311 41.5833 21.2487V16.9987C41.5833 16.2163 40.9491 15.582 40.1666 15.582H34.5Z"
    })), _ref18 || (_ref18 =
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M40.1666 28.3346H34.5L34.5 32.5846H40.1666V28.3346ZM34.5 26.918C33.7176 26.918 33.0833 27.5522 33.0833 28.3346V32.5846C33.0833 33.367 33.7176 34.0013 34.5 34.0013H40.1666C40.9491 34.0013 41.5833 33.367 41.5833 32.5846V28.3346C41.5833 27.5522 40.9491 26.918 40.1666 26.918H34.5Z"
    })), _ref19 || (_ref19 =
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M55.75 28.3346H50.0834L50.0834 32.5846H55.75V28.3346ZM50.0834 26.918C49.301 26.918 48.6667 27.5522 48.6667 28.3346V32.5846C48.6667 33.367 49.301 34.0013 50.0834 34.0013H55.75C56.5324 34.0013 57.1667 33.367 57.1667 32.5846V28.3346C57.1667 27.5522 56.5324 26.918 55.75 26.918H50.0834Z"
    })), _ref20 || (_ref20 =
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M55.75 39.6667H50.0834L50.0834 43.9167H55.75V39.6667ZM50.0834 38.25C49.301 38.25 48.6667 38.8843 48.6667 39.6667V43.9167C48.6667 44.6991 49.301 45.3333 50.0834 45.3333H55.75C56.5324 45.3333 57.1667 44.6991 57.1667 43.9167V39.6667C57.1667 38.8843 56.5324 38.25 55.75 38.25H50.0834Z"
    })), _ref21 || (_ref21 =
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M48.6667 49.5846C48.6667 48.8023 49.3008 48.168 50.0833 48.168H54.3334L52.9167 49.5846H50.0834V53.8346H51.5V55.2513H50.0834C49.301 55.2513 48.6667 54.617 48.6667 53.8346V49.5846Z"
    })), _ref22 || (_ref22 =
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M40.1666 39.6667H34.5L34.5 43.9167H40.1666V39.6667ZM34.5 38.25C33.7176 38.25 33.0833 38.8843 33.0833 39.6667V43.9167C33.0833 44.6991 33.7176 45.3333 34.5 45.3333H40.1666C40.9491 45.3333 41.5833 44.6991 41.5833 43.9167V39.6667C41.5833 38.8843 40.9491 38.25 40.1666 38.25H34.5Z"
    })), _ref23 || (_ref23 =
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M40.1666 49.5846H34.5L34.5 53.8346H40.1666V49.5846ZM34.5 48.168C33.7176 48.168 33.0833 48.8022 33.0833 49.5846V53.8346C33.0833 54.617 33.7176 55.2513 34.5 55.2513H40.1666C40.9491 55.2513 41.5833 54.617 41.5833 53.8346V49.5846C41.5833 48.8022 40.9491 48.168 40.1666 48.168H34.5Z"
    })))
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgStudentRes, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/student-res.81e34746.svg";
export { ForwardRef as ReactComponent };